import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']
const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

const hasTmsUserGroupAccess = hasAccessAll(['tms-user-group:read'])

const fields = (customFields = [], options = {}) => {
  const showLineOrder = options.showLineOrder !== false
  const statusStickyLeft = showLineOrder ? '349.5px' : '229.5px'
  const t = typeof options.t === 'function' ? options.t : null
  const translate = (key, fallback) => {
    if (!t) return fallback

    const translated = t(key)

    return translated === key ? fallback : translated
  }

  return [
    {
      label: translate('delivery.fields.deliveryNumber', 'No. Pengiriman'),
      key: 'number',
      isSortable: true,
      isRedirectable: true,
      tdAttr: {
        style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
      },
      thAttr: {
        style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
      },
      isLocked: true,
    },
    ...(showLineOrder
      ? [
          {
            label: translate('delivery.fields.lineOrder', 'Line Order'),
            key: 'line_order',
            isSortable: true,
            tdAttr: {
              style: 'left:229.5px;position:sticky;min-width:120px;max-width:120px;z-index:1;',
            },
            thAttr: {
              style: 'left:229.5px;position:sticky;min-width:120px;max-width:120px;z-index:1;',
            },
            isLocked: true,
          },
        ]
      : []),
    {
      label: translate('delivery.fields.status', 'Status'),
      key: 'status.name',
      tdAttr: {
        style: `left:${statusStickyLeft};position:sticky;z-index:1;`,
      },
      thAttr: {
        style: `left:${statusStickyLeft};position:sticky;z-index:1;`,
      },
      isLocked: true,
    },
    {
      label: translate('delivery.fields.deliveryType', 'Tipe Pengiriman'),
      key: 'shipment_type',
      isShow: true,
    },
    {
      label: translate('delivery.fields.shipmentNumber', 'No. Shipment'),
      key: 'shipment_number',
      isEllipsis: true,
    },
    {
      label: translate('delivery.fields.referenceNumberText', 'No. Referensi'),
      key: 'reference_number',
      isEllipsis: true,
    },
    {
      label: translate('delivery.fields.refOrder', 'Ref. Order'),
      key: 'external_reference_number',
      scopes: [
        'tms-integration-accurate:create',
        'tms-integration-accurate:read',
        'tms-integration-accurate:delete',
        'tms-integration-accurate:update',
      ],
    },
    {
      label: translate('delivery.fields.fleetTaskNumber', 'No. Penugasan'),
      key: 'fleet_task.number',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.createdDate', 'Tanggal Dibuat'),
      key: 'created_on',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.estimatedPicked', 'Target Diambil'),
      key: 'expected_pickup_on',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.estimatedDelivered', 'Target Terkirim'),
      key: 'expected_delivered_on',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.createdBy', 'Dibuat Oleh'),
      key: 'created_by',
      isSortable: true,
    },
    {
      label: translate('global.field.userGroup', 'Grup Pengguna'),
      key: 'user_group.name',
      isSortable: false,
      isShow: hasTmsUserGroupAccess,
      isEllipsis: true,
    },
    {
      label: translate('delivery.fields.productCategory', 'Kategori Produk'),
      key: 'product_categories',
      isSortable: false,
    },
    {
      label: translate('delivery.fields.shippedCustomerName', 'Pelanggan Penerima'),
      key: 'shipped_customer.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: translate('delivery.fields.billedCustomerName', 'Pelanggan Tertagih'),
      key: 'billed_customer.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: translate('delivery.fields.vendor', 'Vendor'),
      key: 'vendor.name',
      isSortable: true,
      scopes: ['vms:create', 'vms:read', 'vms:update', 'vms:delete'],
      isShow: true,
      isEllipsis: true,
    },
    {
      label: translate('delivery.fields.originAddress', 'Alamat Asal'),
      key: 'origin_address.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: translate('delivery.fields.originCity', 'Kota Asal'),
      key: 'origin_address.city',
      isSortable: true,
      isShow: true,
    },
    {
      label: translate('delivery.fields.destinationAddress', 'Alamat Tujuan'),
      key: 'destination_address.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: translate('delivery.fields.destinationCity', 'Kota Tujuan'),
      key: 'destination_address.city',
      isSortable: true,
      isShow: true,
      isEllipsis: true,
    },
    /**
     * Custom fields are inserted between 'Alamat Tujuan' and 'Total Muatan'
     */
    ...customFields,
    {
      label: translate('delivery.fields.totalLoad', 'Total Muatan'),
      key: 'load_count',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.loadWeight', 'Berat Muatan'),
      key: 'load_weight',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.loadVolume', 'Volume Muatan'),
      key: 'load_volume',
      isSortable: true,
    },
    {
      label: translate('delivery.fields.minTemperature', 'Min. Temperatur'),
      key: 'load_min_temperature',
      isSortable: true,
      formatter: (value) => ((value ?? '') === '' ? `-` : `${value} °C`),
      scopes: ['tms-cold-chain:read'],
    },
    {
      label: translate('delivery.fields.maxTemperature', 'Max. Temperatur'),
      key: 'load_max_temperature',
      isSortable: true,
      formatter: (value) => ((value ?? '') === '' ? `-` : `${value} °C`),
      scopes: ['tms-cold-chain:read'],
    },
    {
      label: translate('delivery.fields.marketingEmployee', 'Karyawan Pemasaran'),
      key: 'marketing_user.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: translate('global.field.tracking', 'Pelacakan'),
      key: 'track_do',
      isSortable: false,
      isLocked: true,
      isShow: true,
      tdAttr: {
        style: 'right:-30px;position:sticky;z-index:1;border-left:1px solid #e6e7ec;',
      },
      thAttr: {
        style: 'right:-30px;position:sticky;z-index:1;border-left:1px solid #e6e7ec',
      },
    },
  ]
}

export default fields
